import view from '../../Enums';
import React from 'react';
import * as IMAGES from '../../Images';
import BecomeAnOyoStyles from '../BecomeAnOyo/BecomeAnOyoStyles';

// example of setting stype

var FormStyles = {};
let key = '';

var vertCenterAbs = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
var horiCenterAbs = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)'
};

var centerAbs = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translateY(-50%) translateX(-50%)'
};

key = '';
FormStyles[''] = {};
FormStyles[''][view.MOBILE] = {};
FormStyles[''][view.DESKTOP] = {};

// step 1 styles
key = 'step_one_parent';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  padding: '0px 5%'
};
FormStyles[key][view.DESKTOP] = {
  display: 'flex',
  position: 'fixed',
  overflowY: 'scroll',
  width: '100%'
};

key = 'step_one_child_1';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '60%',
  position: 'relative',
  paddingLeft: '10%',
  overflowY: 'scroll'
};

key = 'step_one_child_2';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '40%',
  overflow: 'hidden',
  position: 'relative'
};

key = 'oyo_form_image';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

key = 'child_2_child';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  padding: '21% 11%'
};

key = 'form1_icon';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '110px',
  left: '-11px',
  height: '50px',
  display: 'block',
  marginBottom: '34px',
  position: 'relative',
  right: '13px',
  marginTop: '30px'
};

key = 'text_div_form_one';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  marginTop: '84px'
};
FormStyles[key][view.DESKTOP] = {};

key = 'form1_step_one_text';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  fontSize: '14px',
  fontFamily: 'InterphaseMedium',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.36',
  letterSpacing: 'normal',
  color: '#333333'
};
FormStyles[key][view.DESKTOP] = {
  fontSize: '18px',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.11',
  letterSpacing: 'normal',
  color: '#333333',
  fontFamily: 'InterphaseMedium'
};

key = 'form1_step_two_text';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  fontSize: '12px',
  fontWeight: 'normal',
  color: 'rgba(0, 0, 0, 0.54)'
};
FormStyles[key][view.DESKTOP] = {
  fontSize: '16px',
  color: 'rgba(0, 0, 0, 0.54)'
};

key = 'lets_start_contact';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  fontSize: '16px',
  fontFamily: 'InterphaseBold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#333333',
  marginTop: '12px'
};
FormStyles[key][view.DESKTOP] = {
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#333333',
  marginTop: '16px',
  marginBottom: '8px'
};

key = 'all_communications_with';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  marginTop: '4px',
  marginBottom: '16px',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  color: '#222222'
};
FormStyles[key][view.DESKTOP] = {
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  color: '#222222',
  marginBottom: '32px'
};

key = 'input_label_form';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  marginBottom: '4px',
  opacity: '0.87',
  fontSize: '14px',
  fontFamily: 'InterphaseMedium',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: '#222222'
};
FormStyles[key][view.DESKTOP] = {
  opacity: '0.54',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#222222',
  marginBottom: '4px'
};

key = 'form1_input';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  marginBottom: '24px',
  padding: '12px 0px 12px 15px',
  borderRadius: '2px',
  border: 'solid 1px rgba(0, 0, 0, 0.08)',
  backgroundColor: '#ffffff',
  fontSize: '14px',
  fontFamily: 'InterphaseMedium',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(0,0,0,0.87)',
  width: '95.4%'
};
FormStyles[key][view.DESKTOP] = {
  borderRadius: '2px',
  border: 'solid 1px rgba(0, 0, 0, 0.08)',
  backgroundColor: '#ffffff',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgba(0,0,0,0.87)',
  padding: '10px 0px 10px 16px',
  width: '385px',
  marginBottom: '16px'
};

key = 'form1_input_parent';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  position: 'relative'
};
FormStyles[key][view.DESKTOP] = {
  position: 'relative'
};

key = 'type_of_property_parent';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

key = 'type_of_property_flex_parent';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  position: 'relative',
  top: '5px',
  width: '248px',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '20px'
};
FormStyles[key][view.DESKTOP] = {
  position: 'relative',
  top: '5px',
  width: '404px',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '20px'
};

key = 'button_parent_form';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  height: '40px',
  borderRadius: '2px',
  boxShadow: 'rgba(197, 197, 197, 0.5) 0px 4px 16px 0px',
  backgroundColor: 'rgb(255, 255, 255)',
  marginTop: '28px',
  position: 'fixed',
  padding: '16px 0px',
  bottom: '0px',
  left: '0',
  right: '0'
};
FormStyles[key][view.DESKTOP] = {
  display: 'flex',
  bottom: '0px',
  height: '80px',
  left: '0',
  width: '63.995%',
  position: 'fixed'
};

key = 'button_left_form';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '50%',
  height: '100%',
  boxShadow: 'inset 0 1px 0 0 rgba(0, 0, 0, 0.08)',
  backgroundColor: '#ffffff',
  position: 'relative'
};

key = 'button_right_form';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  height: '100%',
  backgroundColor: 'rgb(26, 182, 79)',
  margin: '0px 16px',
  position: 'relative',
  borderRadius: '4px'
};
FormStyles[key][view.DESKTOP] = {
  width: '50%',
  height: '100%',
  backgroundColor: '#1ab64f',
  position: 'relative'
};

key = 'button_left_form_text';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  ...centerAbs,
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgb(0, 0, 0,0.54)',
  transform: 'translateY(-60%) translateX(-50%)',
  fontFamily: 'InterphaseMedium'
};

key = 'button_right_form_text';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  ...centerAbs,
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  color: '#ffffff'
};
FormStyles[key][view.DESKTOP] = {
  ...centerAbs,
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  transform: 'translateY(-60%) translateX(-50%)',
  fontFamily: 'InterphaseMedium'
};

key = 'phone_number_parent_f1';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  width: '95.4%',
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  marginBottom: '24px',
  paddingRight: '15px',
  paddingLeft: '0px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(0,0,0,0.87)',
  height: '48px'
};
FormStyles[key][view.DESKTOP] = {
  position: 'relative',
  height: '45px',
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  width: '404px',
  marginBottom: '16px'
};

key = '';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

key = '';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

key = '';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

key = 'flagImage';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  margin: '0px 6px',
  top: '2.5px'
};
FormStyles[key][view.DESKTOP] = {
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  zIndex: '2',
  display: 'inline-block',
  cursor: 'pointer',
  top: '2px',
  margin: '0px 6px'
};

key = 'dial_Code';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  fontSize: '14px'
};
FormStyles[key][view.DESKTOP] = {
  fontSize: '16px'
};

key = 'flag_parent_span';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  ...vertCenterAbs,
  height: '45px',
  width: '100%'
};

key = 'ph_number_input';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  fontSize: '14px',
  fontFamily: 'InterphaseMedium',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(0,0,0,0.87)',
  border: '0',
  width: '69%',
  height: '46px'
};
FormStyles[key][view.DESKTOP] = {
  border: '0px',
  backgroundColor: 'rgb(255, 255, 255)',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.87)',
  marginBottom: '0px',
  marginLeft: '5px',
  height: '94%',
  width: '71%'
};

key = 'dropdownDivForm';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  position: 'relative',
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  height: '22px',
  marginBottom: '16px',
  width: '95%',
  padding: '10px 0px 10px 15px'
};
FormStyles[key][view.DESKTOP] = {
  position: 'relative',
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  height: '22px',
  marginBottom: '16px',
  width: '387px',
  padding: '10px 0px 10px 16px'
};

key = 'img_form_down_dropdown';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {
  ...vertCenterAbs,
  right: '15px'
};
FormStyles[key][view.DESKTOP] = {
  ...vertCenterAbs,
  right: '15px'
};

key = 'form_one_static_content';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '80%',
  zIndex: '1',
  ...horiCenterAbs,
  top: '167px'
};

key = 'form_stats_entity_parent';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '50px'
};

key = 'form_stats_entity_image';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  width: '70px',
  height: '70px',
  objectFit: 'contain'
};

key = 'form_stats_entity_text_big';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  fontSize: '36px',
  fontFamily: 'InterphaseBold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.11',
  letterSpacing: 'normal',
  color: '#ffffff',
  marginLeft: '20px'
};

key = 'form_stats_entity_text_small';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#ffffff',
  marginLeft: '10px'
};

key = 'why_join_form';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#ffffff',
  fontFamily: 'InterphaseBold',
  marginBottom: '44px'
};

key = '';
FormStyles[key] = {};
FormStyles[key][view.MOBILE] = {};
FormStyles[key][view.DESKTOP] = {};

FormStyles['form_step3_web'] = {};
FormStyles['form_step3_web'][view.MOBILE] = {};
FormStyles['form_step3_web'][view.DESKTOP] = {
  width: '100%',
  height: '830px',
  backgroundColor: '#ffffff',
  overflow: 'hidden',
  zIndex: '1',
  position: 'relative',
  top: '0px',
  left: '0px'
};

FormStyles['form_back_botton'] = {};
FormStyles['form_back_botton'][view.MOBILE] = {};
FormStyles['form_back_botton'][view.DESKTOP] = {
  width: '191px',
  height: '28px',
  borderRadius: '4px',
  border: 'solid 2px #1ab64f',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#1ab64f',
  textAlign: 'center',
  padding: '1.8% 0',
  cursor: 'pointer',
  paddingTop: '10px'
};

FormStyles['form_input_header_style'] = {};

FormStyles['form_input_header_style'][view.DESKTOP] = {
  height: '24px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: '#222222',
  paddingTop: '42px'
};
//editing
FormStyles['form_input_header_style'][view.MOBILE] = {
  height: '80px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: '#222222',
  paddingTop: '18px'
};

FormStyles['input_form_step1'] = {};

FormStyles['input_form_step1'][view.DESKTOP] = {
  width: '74%',
  height: '46px',
  borderRadius: '2px',
  border: 'solid 1px #a6a6a6',
  backgroundColor: '#ffffff',
  marginTop: '4px',
  fontSize: '14px',
  padding: '0 3%',
  padding: ' 0px 3% 0 13%',
  width: '64%',
  paddingLeft: '3%',
  width: '74%'
};
//editing
FormStyles['input_form_step1'][view.MOBILE] = {
  width: '90%',
  height: '46px',
  borderRadius: '2px',
  border: 'solid 1px #a6a6a6',
  backgroundColor: '#ffffff',
  marginTop: '4px',
  fontSize: '14px',
  padding: '0 3%',
  padding: ' 0px 3% 0 13%',
  width: '64%',
  paddingLeft: '3%',
  width: '74%'
};

//step 3
key = '';
FormStyles[''] = {};
FormStyles[''][view.MOBILE] = {};
FormStyles[''][view.DESKTOP] = {};

key = '';
FormStyles['form_oyo_icon'] = {};
FormStyles['form_oyo_icon'][view.MOBILE] = {};
FormStyles['form_oyo_icon'][view.DESKTOP] = {
  position: 'absolute',
  left: '135px',
  top: '24px',
  width: '100px',
  height: '44px'
};

FormStyles['form3_content_container'] = {};
FormStyles['form3_content_container'][view.MOBILE] = {
  position: 'absolute',
  left: '50%',
  top: '200px',
  transform: 'translateY(-50%) translateX(-50%)',
  textAlign: 'center'
};
FormStyles['form3_content_container'][view.DESKTOP] = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translateY(-50%) translateX(-50%)',
  textAlign: 'center'
};

FormStyles['form3_content_heading'] = {};
FormStyles['form3_content_heading'][view.MOBILE] = {
  marginBottom: '40px',
  width: '100%',
  height: '32px',
  opacity: '0.87',
  fontFamily: 'InterphaseMedium',
  fontSize: '24px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
FormStyles['form3_content_heading'][view.DESKTOP] = {
  width: '306px',
  height: '32px',
  opacity: '0.87',
  fontFamily: 'InterphaseMedium',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  display: 'block',
  marginBottom: '40px'
};

FormStyles['form3_subcontent'] = {};
FormStyles['form3_subcontent'][view.MOBILE] = {
  width: '100%',
  height: '24px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#222222'
};
FormStyles['form3_subcontent'][view.DESKTOP] = {
  marginTop: '8px',
  width: '312px',
  height: '24px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#222222',
  display: 'block'
};
FormStyles['form3_success_icon'] = {};
FormStyles['form3_success_icon'][view.MOBILE] = {
  transform: 'translateY(-50%) translateX(-50%)',
  position: 'absolute',
  left: '50%',
  width: '128px',
  height: '128px'
};
FormStyles['form3_success_icon'][view.DESKTOP] = {
  ...centerAbs,
  top: '-110px',
  width: '128px',
  height: '128px'
};

FormStyles['go_to_homepage_button'] = {};
FormStyles['go_to_homepage_button'][view.MOBILE] = {
  transform: 'translateY(-50%) translateX(-50%)',
  position: 'absolute',
  left: '50%',
  top: '215px',
  width: '203px',
  height: '44px',
  borderRadius: '4px',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f'
};
FormStyles['go_to_homepage_button'][view.DESKTOP] = {
  ...centerAbs,
  top: '100px',
  width: '203px',
  height: '46px',
  borderRadius: '4px',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f'
};

FormStyles['go_to_homepage_button_content'] = {};
FormStyles['go_to_homepage_button_content'][view.MOBILE] = {
  ...centerAbs,
  height: '16px',
  fontFamily: 'InterphaseMedium',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  width: '100%'
};
FormStyles['go_to_homepage_button_content'][view.DESKTOP] = {
  ...centerAbs,
  width: '123px',
  height: '16px',
  fontFamily: 'InterphaseMedium',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  width: '100%'
};
FormStyles['form3_footer'] = {};
FormStyles['form3_footer'][view.MOBILE] = {};
FormStyles['form3_footer'][view.DESKTOP] = {
  position: 'absolute',
  bottom: '0px',
  width: '100%',
  left: '0',
  height: '80px',
  boxShadow: 'inset 0 1px 0 0 rgba(0, 0, 0, 0.08)',
  backgroundColor: '#ffffff',
  textAlign: 'center'
};

FormStyles['form3_footer_icon'] = {};
FormStyles['form3_footer_icon'][view.MOBILE] = {};
FormStyles['form3_footer_icon'][view.DESKTOP] = {
  width: '16.5px',
  height: '17px',
  opacity: '0.54',
  marginRight: '10px',
  marginTop: '28px',
  transform: 'translate(5px, 5px)'
};

key = '';
FormStyles['form3_footer_content'] = {};
FormStyles['form3_footer_content'][view.MOBILE] = {};
FormStyles['form3_footer_content'][view.DESKTOP] = {
  height: '24px',
  opacity: '0.54',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  marginRight: '30px',
  paddingBottom: '2px'
};

FormStyles['form3_content_body'] = {};
FormStyles['form3_content_body'][view.MOBILE] = {
  position: 'absolute',
  width: '320px',
  top: '118px',
  left: '50%',
  transform: 'translateY(-50%) translateX(-50%)'
};
FormStyles['form3_content_body'][view.DESKTOP] = {
  ...centerAbs,
  top: '10px'
};

FormStyles['form_small_text'] = {};
FormStyles['form_small_text'][view.MOBILE] = {
  height: '24px',
  opacity: '0.54',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#222222'
};
FormStyles['form_small_text'][view.DESKTOP] = {
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#888'
};
export default FormStyles;
